import { uniq } from "lodash/fp";
import WifiTetheringRoundedIcon from "@material-ui/icons/WifiTetheringRounded";
import CollapsibleMenuList from "../CollapsibleMenuList";
import LicenceModel from "../../models/LicenceModel";

type LicenceMenuProps = {
  licenceList: LicenceModel[],
  currentLicenceId?: number | null,
  onLicenceClick: (number) => void,
}

const LicenceMenuList = ({ licenceList, currentLicenceId, onLicenceClick }: LicenceMenuProps) => {
  const technologyList = uniq(licenceList.map((licence) => licence.technology.name));
  technologyList.sort();

  return (
    <CollapsibleMenuList
      isOpened
      selectItem={onLicenceClick}
      selectedItemId={currentLicenceId}
      groups={technologyList
        .map((technologyName) => {
          return {
            icon: <WifiTetheringRoundedIcon />,
            listTitle: technologyName,
            items: licenceList.filter((licence) => {
              return technologyName === licence?.technology?.name
            }).map((licence) => {
              return {
                secondary: licence.name,
                id: licence.id,
                // icon: <DeviceIcon deviceConfiguration={device?.configuration} />,
              }
            })
          }
        })}
      />
  )
}

export default LicenceMenuList;